import { Box, Button, FormControl, FormLabel } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

import { useHookForm } from '@/hooks/useHookForm';

import { FormControlError } from '@/components/FormControlError/FormControlError';
import MemberNumberOrEmailInput from '@/components/UI/Inputs/MemberNumberOrEmailInput';

import { emailValidation } from '@/validators/email';

interface RemindPasswordFormProps {
    onSubmit?: (memberEmail: string) => void;
}

interface RemindPasswordForm {
    memberEmail: string;
}

export function RemindPasswordForm(props: RemindPasswordFormProps) {
    const { formState, register, handleSubmit } = useHookForm<RemindPasswordForm>();

    const onSubmit = (data: RemindPasswordForm) => {
        props?.onSubmit?.(data.memberEmail.trim());
    };

    const userFormControl = register('memberEmail', {
        required: {
            value: true,
            message: 'field-is-required'
        },
        validate: (value) => emailValidation(value)
    });

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
                <Box maxW="350px" mx="auto" mt={4}>
                    <FormControl isRequired isInvalid={!!formState.errors[userFormControl.name]}>
                        <FormLabel fontWeight="medium" mb={2} color="black">
                            <FormattedMessage id="page.remind-password.label"></FormattedMessage>
                        </FormLabel>
                        <FormControlError control={userFormControl} formState={formState}>
                            <MemberNumberOrEmailInput
                                formControlRef={userFormControl}
                                inputProps={{
                                    isRequired: true
                                }}
                            />
                        </FormControlError>
                    </FormControl>
                    <Button
                        type="submit"
                        mx="auto"
                        display="block"
                        mt={12}
                        px={7}
                        colorScheme="brand"
                    >
                        <FormattedMessage id="send" />
                    </Button>
                </Box>
            </form>
        </>
    );
}
